import { getPosting } from '../../../apiclient/resources/posting';
import { completeLocation } from '../../../services/utils/leads';
import * as actions from './actions';

const fetchPostingFiltered = id => dispatch => {
  dispatch(actions.fetchPostingFiltered(id));
  getPosting(id).then(({ error, data }) => {
    if (!error) {
      data.completeLocation = completeLocation(data);
      data.currency = data.price ? data.price.currency : '';
      data.price = data.price ? data.price.amount : '';
      dispatch(actions.fetchPostingFilteredSucceeded(data));
    } else {
      dispatch(actions.fetchPostingFilteredFailed(id));
    }
  });
};
export { fetchPostingFiltered };
